// Device-based private guardian identifier (no login). Stored locally.
export const getGuardianId = () => {
  let id = localStorage.getItem("adaptience_guardian_id");
  if (!id) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `g-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("adaptience_guardian_id", id);
  }
  return id;
};
